import React from "react";

const Java_Scanner_nextLine = () => {
  return (
    <div>
      <h1>Java Scanner nextLine</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Scanner nextLine in Java.</p>
    </div>
  );
};

export default Java_Scanner_nextLine;
